import React from "react";
import { cn } from "../../../utils/cn";

const AuthTabs = ({ active, onChange }) => {
  const tabs = [
    { id: "login", label: "Entrar" },
    { id: "signup", label: "Criar conta" },
  ];

  return (
    <div
      className="flex rounded-xl border border-border bg-muted/50 p-1 mb-6"
      role="tablist"
      aria-label="Autenticação"
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={active === tab.id}
          className={cn(
            "flex-1 rounded-lg py-2.5 text-sm font-semibold transition-smooth",
            active === tab.id
              ? "bg-card text-foreground shadow-soft-sm"
              : "text-muted-foreground hover:text-foreground"
          )}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default AuthTabs;
